import useAuthStore from '@/store/useAuthStore';
import useSubscriptionStore, { getCurrentTier } from '@/store/useSubscriptionStore';
export type SubjectAccessResult = 'allowed' | 'needs_selection' | 'blocked';

/**
 * Check and enforce the free-tier subject restriction.
 * - Non-free users: always allowed.
 * - Free user, no locked subject: require confirmation, return 'needs_selection'.
 * - Free user, matching subject: return 'allowed'.
 * - Free user, different subject: return 'blocked'.
 *
 * Call this after the quest subject is known (inside fetchQuset / initializeChat).
 */
export async function checkSubjectAccess(questSubject: string | null | undefined): Promise<SubjectAccessResult> {
  if (!questSubject) return 'allowed';

  // Ensure subscription data is loaded before checking tier.
  // Direct navigation to /learn or /practice may skip HomeTab where
  // loadForStudent is normally called, leaving the store uninitialized.
  const subStore = useSubscriptionStore.getState();
  if (!subStore.initialized) {
    const profile = useAuthStore.getState().profile;
    if (profile?.id) {
      await subStore.loadForStudent(profile.id);
    }
  }

  const tier = getCurrentTier();
  if (tier !== 'free') return 'allowed';

  const profile = useAuthStore.getState().profile;
  // If profile not loaded yet, block access (fail closed)
  if (!profile) return 'blocked';

  const lockedSubject = profile.free_subject;

  // No lock yet — let the caller prompt the user before confirming.
  if (!lockedSubject) {
    return 'needs_selection';
  }

  return lockedSubject.replace(/_/g, '-') === questSubject.replace(/_/g, '-') ? 'allowed' : 'blocked';
}
